import { FilterSection } from '@/types/inventory';

export const inTransitDefaultImageUrl =
  'https://res.cloudinary.com/la-mesa-rv/image/upload/f_auto,q_auto/v1657821676/brand-assets/lamesarv/unit-in-transit_eutjhq.png';
export const noPhotoDefaultImageUrl =
  'https://res.cloudinary.com/la-mesa-rv/image/upload/v1746033953/photos-coming-soon_c5kpgr.jpg';

export const mobileFiltersClass = 'mobile-filters-button';

export const inventoryItemMinWidth = 340;

export const maxSlidesInInventorySlider = 5;

export const INVENTORY_IMAGE_WIDTH = 600;
export const INVENTORY_IMAGE_HEIGHT = 500;
export const INVENTORY_BIG_IMAGE_WIDTH = 600;
export const INVENTORY_BIG_IMAGE_HEIGHT = 500;

export const PDP_MINIATURE_WIDTH_REM = 7.5;

export const SORT_BY_SECTION = 'Sort By';

export const RANGE_FILTER_SECTIONS: Set<string> = new Set([
  FilterSection.LENGTH,
  FilterSection.PRICE,
  FilterSection.YEAR,
  // FilterSection.SLEEPS,
]);

export const SEARCHABLE_FILTER_SECTIONS: Set<string> = new Set([
  FilterSection.MAKE,
  FilterSection.MODEL,
  FilterSection.FLOOR_PLAN,
  FilterSection.FEATURES,
]);

export const CUSTOM_RV_TYPE_SORT = ['Class A', 'Class B', 'Class C', '5th Wheel', 'Travel Trailer', 'Toy Hauler'];

export const ITEMS_PER_PAGE_MOBILE = 7;
export const ITEMS_PER_PAGE_TABLET = 12;
export const ITEMS_PER_PAGE_DESKTOP = 15;

export const MAX_ITEMS_PER_PAGE = 45;
